import { useRef } from 'react'
import { useUnmount } from 'ahooks'
import { setDocumentTitle } from '@bcz/fe-interface'

/**
 * @param {string} title 要设置的文档标题
 * @param {object} [opt]
 * @param {boolean} [opt.restoreOnUnmount] 页面卸载时恢复原始标题？
 */
export function useDocumentTitle(title, { restoreOnUnmount = false } = {}) {
  const prevTitleRef = useRef(document.title)

  if (document.title !== title) {
    setDocumentTitle(title)
  }

  useUnmount(() => {
    if (restoreOnUnmount) {
      setDocumentTitle(prevTitleRef.current)
    }
  })
}
